export default __webpack_public_path__ + "static/media/old-time.f29577da.svg";